export function validateUnreadCount(count) {
  if (!Number.isSafeInteger(count) || count < 0) throw new Error('Unread count is unavailable');
  return count;
}

// One request at a time; disposal and deadlines prevent late UI updates.
export function createNotificationCountLoader(readCount, onState, { timeoutMs = 15000 } = {}) {
  let state = { count: null, checkedAt: null, loading: false, error: false };
  let active = null;
  let disposed = false;
  const publish = patch => {
    state = { ...state, ...patch };
    if (!disposed) onState(state);
  };
  function refresh() {
    if (disposed) return Promise.resolve();
    if (active) return active.promise;
    const controller = new AbortController();
    const operation = { controller, promise: null };
    active = operation;
    publish({ loading: true });
    let timer;
    let onAbort;
    const aborted = new Promise((_, reject) => {
      onAbort = () => reject(new Error('Unread count request stopped'));
      controller.signal.addEventListener('abort', onAbort, { once: true });
      timer = setTimeout(() => controller.abort(), timeoutMs);
    });
    operation.promise = Promise.race([
      Promise.resolve().then(() => readCount({ signal: controller.signal })).then(validateUnreadCount),
      aborted,
    ]).then(count => {
      if (!disposed && active === operation) publish({ count, checkedAt: Date.now(), error: false });
    }).catch(() => {
      if (!disposed && active === operation) publish({ error: true });
    }).finally(() => {
      clearTimeout(timer);
      controller.signal.removeEventListener('abort', onAbort);
      if (active === operation) {
        active = null;
        if (!disposed) publish({ loading: false });
      }
    });
    return operation.promise;
  }
  function dispose() {
    disposed = true;
    active?.controller.abort();
    active = null;
  }
  return { refresh, dispose };
}
